import { TreatmentRegionalBlockEnum } from "requests";

export const LEFT_REGIONAL_BLOCKS_OPTIONS = [
  {
    value: TreatmentRegionalBlockEnum.Infraorbital,
    label: "Infraorbital",
    name: "leftInfraorbital"
  },
  {
    value: TreatmentRegionalBlockEnum.Maxillary,
    name: "leftMaxillary",
    label: "Maxillary"
  },
  {
    value: TreatmentRegionalBlockEnum.RostralMandibular,
    name: "leftRostralMandibular",
    label: "Rostral Mandibular"
  },
  {
    value: TreatmentRegionalBlockEnum.InferiorAlveolar,
    name: "leftInferiorAlveolar",
    label: "Inferior Alveolar"
  }
];

export const REGIONAL_BLOCKS_VALUES = [
  "leftInferiorAlveolar",
  "leftInfraorbital",
  "leftMaxillary",
  "leftRostralMandibular",
  "rightInferiorAlveolar",
  "rightInfraorbital",
  "rightMaxillary",
  "rightRostralMandibular"
] as const;
